module.exports = __webpack_public_path__ + "tm.c8f7210db34658ec1fbe.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/tm.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/tm.svg
// module chunks = styles